import { useFormik } from "formik";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import {
  initialChangePassValues,
  changePassValidationSchema,
} from "../../../validation";
import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";
import { Loader } from "components/Loader";
import { changePassword } from "../../../service";
import { PasswordValidationPopup } from "features/Auth/v2/components/PasswordValidationPopup";
import { Form, Input } from "components/Form";
import { Button } from "components/Button/index";
import { ChangePasswordModalContainer } from "./ChangePasswordModal.styles";

export const ChangePasswordModal = ({ show, onHide }) => {
  const dispatch = useDispatch();

  const handleSubmit = async (values) => {
    try {
      await changePassword(values);
      formik.resetForm();
      dispatch(
        toast({
          body: "Your password has been updated",
        })
      );
      onHide(); // Close modal on success
    } catch (error) {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    }
  };

  const formik = useFormik({
    onSubmit: handleSubmit,
    initialValues: initialChangePassValues,
    validationSchema: changePassValidationSchema,
  });

  const handleModalClose = () => {
    formik.resetForm();
    onHide();
  };

  return (
    <ChangePasswordModalContainer
      show={show}
      onHide={handleModalClose}
      heading="Change Your Password"
      size="md"
    >
      <div className="change-password-form">
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Input
                type="password"
                label="Current password"
                placeholder="Enter password"
                className="security-password-input"
                isInvalid={
                  formik.touched.current_password &&
                  formik.errors.current_password
                }
                {...formik.getFieldProps("current_password")}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xl={12} lg={12} md={12}>
              <PasswordValidationPopup errors={formik.errors.new_password}>
                <Input
                  type="password"
                  label="New password"
                  placeholder="Enter password"
                  className="security-password-input"
                  isInvalid={
                    formik.touched.new_password && formik.errors.new_password
                  }
                  {...formik.getFieldProps("new_password")}
                />
              </PasswordValidationPopup>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xl={12} lg={12} md={12}>
              <Input
                type="password"
                label="Confirm new password"
                placeholder="Enter password"
                className="security-password-input"
                isInvalid={
                  formik.touched.confirm_new_password &&
                  formik.errors.confirm_new_password
                }
                {...formik.getFieldProps("confirm_new_password")}
              />
              {formik.touched.confirm_new_password &&
                formik.errors.confirm_new_password && (
                  <div className="form-error">
                    {formik.errors.confirm_new_password}
                  </div>
                )}
            </Col>
          </Row>
          <div className="modal-actions">
            <Button
              type="button"
              variant="secondary"
              size="small"
              onClick={handleModalClose}
              className="cancel-btn"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="submit-btn"
              disabled={!formik.isValid}
              size="small"
            >
              {formik.isSubmitting ? <Loader className="on-btn" /> : "Confirm"}
            </Button>
          </div>
        </Form>
      </div>
    </ChangePasswordModalContainer>
  );
};

ChangePasswordModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
